import { useEffect, useState } from 'react';

import { Box, Typography } from '@mui/material';

import NavSolicitation from './NavSolicitation';
import FadeAnimation from 'components/views/FadeAnimation';
import FormEmail from 'components/views/ServiceFaq/FormEmail';

import { ReactComponent as IcOtherSolicitation } from 'assets/icons/ic-other-solicitation.svg';

import { Ul } from './styles';

const textStyleError = {
    fontSize: '.9375rem',
    fontWeight: 600
}

const OtherSolicitation = () => {
    const dateNow = new Date();

    const [showContact, setShowContact] = useState(false);
    const [serviceAvailable, setServiceAvailable] = useState(false);

    useEffect(() => {
        if (dateNow.getDay() > 0) {
            if (dateNow.getDay() === 6 && dateNow.getHours() < 14 && dateNow.getHours() > 7) {
                setServiceAvailable(true);
            } else if (dateNow.getDay() < 6 && dateNow.getHours() < 20 && dateNow.getHours() > 7) {
                setServiceAvailable(true);
            } else {
                setServiceAvailable(false);
            }
        } else {
            setServiceAvailable(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <FadeAnimation>
            <Box>
                <NavSolicitation title='Demais solicitações' icon={<IcOtherSolicitation />} />
                {serviceAvailable ?
                    <Box sx={{ width: '100%', maxWidth: '100%', backgroundColor: '#EFF2F5', padding: '.9rem 0 .8rem' }}>
                        <Box sx={{ display: 'flex', paddingBottom: '.8rem', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', position: 'relative' }} onClick={() => setShowContact(!showContact)}>
                            <Typography sx={{ fontSize: '.875rem', fontWeight: 700 }}>
                                Envie sua dúvida pra gente!
                            </Typography>
                        </Box>
                        <FormEmail />
                    </Box>
                    :
                    <Box sx={{ display: 'flex', marginTop: '5.25rem', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                        <Box sx={{
                            border: '1.5px solid rgba(10, 168, 227, 0.45)',
                            borderRadius: '10px',
                            maxWidth: '21.875rem',
                            padding: '1.5625rem 2rem',
                            marginTop: '-30px',
                            backgroundColor: 'white',
                            textAlign: 'center'
                        }}>
                            <Typography sx={textStyleError} paddingBottom='.875rem'>
                                Prezado cliente, nosso horário de<br />
                                atendimento é de:
                            </Typography>

                            <Ul>
                                <li>
                                    <Typography sx={textStyleError}>
                                        Segunda a sexta das 8h às 19h
                                    </Typography>
                                </li>
                                <li>
                                    <Typography sx={textStyleError}>
                                        Sábado das 8h às 13h
                                    </Typography>
                                </li>
                            </Ul>

                            <Typography sx={textStyleError} marginTop='-.5625rem'>
                                Entre em contato novamente.
                            </Typography>
                        </Box>
                    </Box>
                }
            </Box>
        </FadeAnimation>
    );
}

export default OtherSolicitation;